import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { jobCreationSteps } from '../../../../constants/jobs';
import ItemIconsList from './ItemIconsList';
import NavButtons from './NavButtons';
import VerifiedCheckIn from '../VerifiedCheckIn';

export default class DressCodeDescriptionStep extends Component {
  static propTypes = {
    dressCodesList: PropTypes.array.isRequired,
    dressCodeId: PropTypes.number.isRequired,
    dressCode: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    whereToReport: PropTypes.string.isRequired,
    handleChangeDressCode: PropTypes.func.isRequired,
    isThirdStepFilled: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired,
    handleSwitch: PropTypes.func
  };

  state = {
    dressCodeInstructAreOpened: false,
    additionalInstructAreOpened: false
  };

  openDressCodeInstructions = () => {
    this.setState({
      dressCodeInstructAreOpened: true
    });
  };

  fillCovidInstructions = () => {
    let x = document.getElementById('additional-instructions-textarea');
    x.value = 'PROOF OF COVID-19 VACCINATION REQUIRED! ';
  };

  render () {
    const { goToStep, isThirdStepFilled, dressCodesList, dressCodeId, handleChangeDressCode, dressCode, description,
      handleChangeTextInput, whereToReport, checkin_verification_required, handleSwitch, company } = this.props;
    const { dressCodeInstructAreOpened } = this.state;
    return (
      <React.Fragment>
        <VerifiedCheckIn
          onChange={() => handleSwitch('checkin_verification_required')}
          isChecked={checkin_verification_required}
          company={company}
        />

        <section className='job-posting-section'>
          <header><h4>Choose The Dress Code</h4></header>
          <ItemIconsList
            listData={dressCodesList}
            selectedItemId={dressCodeId}
            chooseItemHandler={handleChangeDressCode}
            iconSourceFieldName='image_url'
            labelFieldName='description_en'
          />
          <button className='additional-link non-button mb-2' onClick={this.openDressCodeInstructions}>
            Add Dress Code Instructions
          </button>
          { dressCodeInstructAreOpened && (
            <textarea
              id='dress-code-textarea'
              className='input input-textarea'
              name='dress_code'
              placeholder='Write dress code requirements...'
              value={dressCode || ''}
              onChange={handleChangeTextInput}
            />
          )}
        </section>
        <section className='job-posting-section'>
          <header><h4>Proof of COVID-19 Vaccination</h4></header>
          <button className='button button-primary' onClick={this.fillCovidInstructions}>
            Click This If This Position Requires Proof of COVID-19 Vaccination
          </button>
          <p>Note will be added below in additional details.</p>
        </section>
        <section className='job-posting-section'>
          <header><h4>Enter Job Description and Instructions</h4></header>
          <textarea
            id='description-textarea'
            className='input input-textarea'
            name='description'
            placeholder='Type description here...'
            value={description || ''}
            onChange={handleChangeTextInput}
          />
          <br />
          <header><h4>Enter Additional Details (required)</h4></header>
          <textarea
            id='additional-instructions-textarea'
            className='input input-textarea'
            name='where_to_report'
            placeholder='Enter instructions on where to report, who to meet, parking, security, etc.'
            value={whereToReport || ''}
            onChange={handleChangeTextInput}
          />
        </section>
        <NavButtons
          showNextButton={isThirdStepFilled()}
          goToStep={goToStep}
          backStepId={jobCreationSteps.second.id}
          nextStepId={jobCreationSteps.summary.id}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/DressCodeDescriptionStep.js